import { useState } from 'react';

const projects = [
  {
    id: 1,
    image:
      'https://static.readdy.ai/image/be4637b51fa2c7a7dcdb39fcd9b97fd2/80def461787a505a61783016d40732b6.jpeg',
    title: 'Commercial Carpet Installation',
    category: 'Corporate',
    location: 'Boca Raton, FL',
  },
  {
    id: 2,
    image:
      'https://static.readdy.ai/image/be4637b51fa2c7a7dcdb39fcd9b97fd2/26fcb607961c61747b00d65985552483.jpeg',
    title: 'Vinyl Flooring — Rehabilitation Center',
    category: 'Healthcare',
    location: 'Florida',
  },
  {
    id: 3,
    image:
      'https://static.readdy.ai/image/be4637b51fa2c7a7dcdb39fcd9b97fd2/9f9ac66f9420963586af79f9e65ab7b1.jpeg',
    title: 'Marble Tile Staircase Installation',
    category: 'Residential',
    location: 'Florida',
  },
  {
    id: 4,
    image:
      'https://static.readdy.ai/image/be4637b51fa2c7a7dcdb39fcd9b97fd2/60454dff52b1cabab1d800bb4ebc519f.jpeg',
    title: 'Bathroom Wall Tile Installation',
    category: 'Residential',
    location: 'Florida',
  },
  {
    id: 5,
    image:
      'https://static.readdy.ai/image/be4637b51fa2c7a7dcdb39fcd9b97fd2/4095ee47519e4d0b3282cec5005c1fdc.jpeg',
    title: 'LVP Flooring — Commercial Space',
    category: 'Corporate',
    location: 'Florida',
  },
  {
    id: 10,
    image:
      'https://static.readdy.ai/image/be4637b51fa2c7a7dcdb39fcd9b97fd2/048d00dca50bfcd3335ce9ee6c134d11.jpeg',
    title: 'Shower Marble Tile Installation',
    category: 'Residential',
    location: 'Florida',
  },
  {
    id: 6,
    image:
      'https://public.readdy.ai/ai/img_res/bd4e8de018689e34ee5bc4854846326c.jpg',
    title: 'Hardwood Flooring — Luxury Residence',
    category: 'Residential',
    location: 'Palm Beach, FL',
  },
  {
    id: 7,
    image:
      'https://readdy.ai/api/search-image?query=commercial%20laminate%20flooring%20installation%20in%20modern%20retail%20store%20space%20clean%20professional%20finish%20durable%20surface%20bright%20interior%20contemporary%20design%20high%20traffic%20area%20commercial%20grade%20flooring%20South%20Florida%20retail%20environment&width=600&height=450&seq=portfolio-laminate-01&orientation=landscape',
    title: 'Laminate Flooring — Retail Space',
    category: 'Retail',
    location: 'Miami, FL',
  },
  {
    id: 8,
    image:
      'https://readdy.ai/api/search-image?query=luxury%20vinyl%20plank%20flooring%20installation%20in%20modern%20corporate%20office%20space%20with%20warm%20wood%20tones%20clean%20lines%20professional%20finish%20high%20end%20commercial%20interior%20polished%20surface%20natural%20light%20streaming%20through%20windows%20elegant%20business%20environment%20South%20Florida%20style&width=600&height=450&seq=portfolio-lvp-01&orientation=landscape',
    title: 'Luxury Vinyl Plank — Office Suite',
    category: 'Corporate',
    location: 'Fort Lauderdale, FL',
  },
  {
    id: 9,
    image:
      'https://readdy.ai/api/search-image?query=large%20scale%20commercial%20carpet%20tile%20installation%20in%20hotel%20lobby%20elegant%20pattern%20luxury%20hospitality%20interior%20warm%20ambient%20lighting%20professional%20flooring%20craftsmanship%20grand%20entrance%20area%20premium%20surface%20Florida%20hotel&width=600&height=450&seq=portfolio-hotel-01&orientation=landscape',
    title: 'Carpet Tile — Hotel Lobby',
    category: 'Hospitality',
    location: 'West Palm Beach, FL',
  },
];

const categories = [
  'All',
  'Corporate',
  'Residential',
  'Retail',
  'Healthcare',
  'Hospitality',
];

export default function Portfolio() {
  const [activeCategory, setActiveCategory] = useState('All');
  const [lightbox, setLightbox] = useState<{ open: boolean; index: number }>({
    open: false,
    index: 0,
  });

  const filtered =
    activeCategory === 'All'
      ? projects
      : projects.filter((p) => p.category === activeCategory);

  const openLightbox = (index: number) => {
    setLightbox({ open: true, index });
  };

  const closeLightbox = () => {
    setLightbox({ open: false, index: 0 });
  };

  const navigateLightbox = (direction: number) => {
    setLightbox((prev) => ({
      open: true,
      index: (prev.index + direction + filtered.length) % filtered.length,
    }));
  };

  return (
    <section id="portfolio" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <div className="flex items-center space-x-2 mb-4">
            <div className="w-2 h-2 bg-[#FF6B35] rounded-full"></div>
            <p className="text-sm font-semibold text-gray-600 uppercase tracking-wider">
              OUR WORK
            </p>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-2">
            Completed Projects
          </h2>
          <p className="text-3xl font-serif italic text-[#2E5C8A]">
            Quality You Can See
          </p>
        </div>

        <div className="flex flex-wrap gap-3 mb-12">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`px-5 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                activeCategory === cat
                  ? 'bg-[#FF6B35] text-white shadow-md'
                  : 'bg-white text-gray-600 hover:bg-gray-100 border border-gray-200'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map((project, index) => (
            <div
              key={project.id}
              onClick={() => openLightbox(index)}
              className="group relative rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <div className="w-full h-72 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  title={`${project.title} - L&A Contract Flooring`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-6">
                <span className="text-xs font-semibold text-[#FF6B35] uppercase tracking-wider mb-1">
                  {project.category}
                </span>
                <h3 className="text-lg font-bold text-white mb-1">
                  {project.title}
                </h3>
                <div className="flex items-center space-x-1 text-white/80">
                  <i className="ri-map-pin-line text-sm w-4 h-4 flex items-center justify-center"></i>
                  <span className="text-sm">{project.location}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a
            href="#contact"
            className="inline-flex items-center space-x-2 px-8 py-4 bg-[#2E5C8A] text-white text-sm font-semibold rounded-full hover:bg-[#2E5C8A]/90 transition-all whitespace-nowrap cursor-pointer"
          >
            <span>DISCUSS YOUR PROJECT</span>
            <i className="ri-arrow-right-line text-lg w-5 h-5 flex items-center justify-center"></i>
          </a>
        </div>
      </div>

      {lightbox.open && (
        <div
          className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4"
          onClick={closeLightbox}
        >
          <button
            onClick={(e) => {
              e.stopPropagation();
              closeLightbox();
            }}
            className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center text-white/80 hover:text-white transition-colors cursor-pointer"
          >
            <i className="ri-close-line text-3xl"></i>
          </button>

          <button
            onClick={(e) => {
              e.stopPropagation();
              navigateLightbox(-1);
            }}
            className="absolute left-4 md:left-8 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-all cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-2xl"></i>
          </button>

          <div
            className="max-w-5xl w-full max-h-[85vh] flex flex-col items-center"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="w-full h-[70vh] rounded-xl overflow-hidden">
              <img
                src={filtered[lightbox.index].image}
                alt={filtered[lightbox.index].title}
                className="w-full h-full object-contain"
              />
            </div>
            <div className="mt-4 text-center">
              <h3 className="text-xl font-bold text-white">
                {filtered[lightbox.index].title}
              </h3>
              <p className="text-white/60 text-sm mt-1">
                {filtered[lightbox.index].category} —{' '}
                {filtered[lightbox.index].location}
              </p>
            </div>
          </div>

          <button
            onClick={(e) => {
              e.stopPropagation();
              navigateLightbox(1);
            }}
            className="absolute right-4 md:right-8 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-all cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-2xl"></i>
          </button>
        </div>
      )}
    </section>
  );
}
